module.exports = __webpack_public_path__ + "static/spring-active-phone-6dac075aa7020623dd026878d1302660.png";